app.service("SiteHelper", ['$rootScope', function ($rootScope) {

    const helper = this;

    const hiddenTextArea = document.createElement("textarea");
    hiddenTextArea.setAttribute("type", "hidden");

    this.isFunction = function (value) {
        return value && {}.toString.call(value) === '[object Function]';
    }

    this.isObject = function (value) {
        return typeof value === 'object' && value !== null && !helper.isArray(value);
    }

    this.isArray = function (value) {
        return Array.isArray(value);
    }

    this.isTouchDevice = function () {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    this.requireString = function (value) {
        if (helper.isObject(value) || helper.isArray(value)) {
            JSON.stringify(value);
        }
        return String(value)
    }


    this.sharedArrayValues = function (array0, array1) {
        const sharedValues = [];
        if (!array0 || !array0.length || !array1 || !array1.length) {
            return sharedValues;
        }
        for (let i = 0; i < array0.length; i++) {
            const value = array0[i];
            if (array0.indexOf(value) < i) {
                continue;
            }
            if (array1.indexOf(value) !== -1) {
                sharedValues.push(value);
            }
        }
        return sharedValues;
    }

    function cloneFunction(root, func, inheritSuper) {

        let cloneSuper = null;

        if (func.context && func.context.self) {
            cloneSuper = func.context.super ? cloneFunction(root, func.context.super, inheritSuper) : null;
            func = func.context.self;
        }
        const context = {
            root: root,
            super: cloneSuper ? cloneSuper : inheritSuper
        }

        const returnFunc = function () {
            return func.apply(context, arguments)
        }
        context.self = func;
        returnFunc.context = context;

        return returnFunc;

    }

    function inheritFunction(root, fromFunc, toFunc) {
        const inheritSuper = cloneFunction(root, fromFunc);
        return cloneFunction(root, toFunc, inheritSuper);
    }

    this.decodeHTML = function (html) {
        hiddenTextArea.innerHTML = html;
        return hiddenTextArea.value;
    }

    this.requireObject = function (possibleObject) {
        if (!possibleObject) {
            return {}
        }
        if (helper.isObject(possibleObject)) {
            return possibleObject;
        }
        const object = {};
        if (helper.isArray(possibleObject)) {
            for (let key in possibleObject) {
                object[key] = possibleObject[key];
            }
        }
        return object;
    }

    this.requireArray = function (possibleArray) {
        if (!possibleArray) {
            return []
        }
        if (helper.isArray(possibleArray)) {
            return possibleArray;
        }
        const array = [];
        if (helper.isObject(possibleArray)) {
            for (let key in possibleArray) {
                array.push(possibleArray[key])
            }
        }
        return array;
    }

    this.multipleSourceCloneChoices = function (multipleSourceFromChoices, choiceOrder) {
        const fromChoices = {};
        for (let i = 0; i < multipleSourceFromChoices.length; i++) {
            const sourceFromChoices = multipleSourceFromChoices[i];
            for (let choiceID in sourceFromChoices) {
                fromChoices[choiceID] = sourceFromChoices[choiceID];
            }
        }
        return helper.cloneChoices(fromChoices, choiceOrder);
    }


    this.filterChoices = function (fromChoices, choiceOrder) {
        const choices = {};
        for (let i = 0; i < choiceOrder.length; i++) {
            const choiceID = choiceOrder[i];
            const choice = fromChoices[choiceID];
            if (choice) {
                choices[choiceID] = choice;
            }
        }
        return choices;
    }

    this.cloneChoices = function (fromChoices, choiceOrder, withValues, ignoreHidden, ignoreDisabled) {
        let choiceID, choice, choiceValues;
        const choices = {};
        if (choiceOrder) {
            for (let i = 0; i < choiceOrder.length; i++) {
                choiceID = choiceOrder[i];
                choice = fromChoices[choiceID];
                if (choice) {
                    if (ignoreHidden && choice.hidden) {
                        continue;
                    }
                    if (ignoreDisabled && choice.disabled) {
                        continue;
                    }
                    choiceValues = withValues ? withValues[choiceID] : null;
                    choices[choiceID] = choice.clone(choiceValues);
                }
            }
        } else {
            for (choiceID in fromChoices) {
                choiceValues = withValues ? withValues[choiceID] : null;
                choices[choiceID] = fromChoices[choiceID].clone(choiceValues);
            }
        }
        return choices;
    }

    this.basicClone = function (cloneClass, cloneFrom, newValues, ignoreKeys, cloneChoices) {
        const model = new cloneClass();

        ignoreKeys = ignoreKeys ? ignoreKeys : {};
        for (let key in cloneFrom) {
            if (ignoreKeys[key]) {
                continue;
            }
            let newValue = cloneFrom[key];
            if (helper.isFunction(newValue)) {
                newValue = cloneFunction(model, newValue);
            } else if (helper.isObject(newValue)) {
                newValue = helper.simpleCloneObject(newValue);
            } else if (helper.isArray(newValue)) {
                newValue = helper.simpleCloneArray(newValue);
            }
            model[key] = newValue;
        }
        this.applyValues(model, newValues);
        return model;
    }

    this.applyValues = function (object, newValues, ignoreKeys) {
        if (!newValues) {
            return;
        }
        for (let key in newValues) {
            if (ignoreKeys && ignoreKeys[key]) {
                continue;
            }
            let newValue = newValues[key];
            if (helper.isFunction(newValue)) {
                const previousValue = object[key];
                if (previousValue && helper.isFunction(previousValue)) {
                    newValue = inheritFunction(object, previousValue, newValue);
                } else {
                    newValue = cloneFunction(object, newValue);
                }
            }
            object[key] = newValue;
        }
    }

    this.createChoiceList = function (choices, choiceOrder) {
        const list = [];
        for (let i = 0; i < choiceOrder.length; i++) {
            const id = choiceOrder[i];
            const itemChoiceVO = choices[id];
            if (itemChoiceVO) {
                list.push(itemChoiceVO);
            }
        }
        return list;
    }

    this.idListFromObjectList = function (objectList, distinct) {
        const idList = [];
        for (let i = 0; i < objectList.length; i++) {
            const id = objectList[i].id;
            if (id && (!distinct || !idList.includes(id))) {
                idList.push(id);
            }
        }
        return idList;
    }

    this.objectFromIdObjectList = function (objectList) {
        const object = {};
        for (let i = 0; i < objectList.length; i++) {
            const item = objectList[i];
            const id = item.id;
            if (id) {
                object[id] = item
            }
        }
        return object;
    }

    this.alphaNumeric = function (string) {
        return string.replace(/[^0-9A-Z]+/gi,"");
    }

    this.slugToID = function (string) {
        string = string ? string.split("-").join("_") : "";
        return string
    }

    this.idToSlug = function (id) {
        return id ? id.split("_").join("-") : "";
    }

    this.slugify = function (string) {
        return string.toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    this.keySort = function (object) {
        return Object.keys(object).sort().reduce(
            (obj, key) => {
                obj[key] = object[key];
                return obj;
            },
            {}
        );
    }


    this.resetObject = function (object) {
        for (let key in object) {
            delete object[key];
        }
    }

    this.simpleCloneObject = function (object, toObject, newToObject) {
        if (toObject && newToObject) {
            toObject = helper.simpleCloneObject(toObject);
        }
        toObject = toObject ? toObject : {};
        if (!object) {
            return toObject;
        }
        for (let key in object) {
            toObject[key] = object[key];
        }
        return toObject;
    }

    this.simpleCloneArray = function (array) {
        const clonedArray = [];
        for (let i = 0; i < array.length; i++) {
            clonedArray.push(array[i]);
        }
        return clonedArray;
    }

    this.arrayToObjectKeys = function (array) {
        const object = {};
        for (let i = 0; i < array.length; i++) {
            object[array[i]] = true;
        }
        return object;
    }

    this.keyCount = function (object) {
        let count = 0;
        for (let key in object) {
            count++;
        }
        return count;
    }

    this.firstObjectKey = function (object) {
        for (let key in object) {
            return key;
        }
        return null;
    }

    this.firstObjectValue = function (object) {
        for (let key in object) {
            return object[key];
        }
        return null;
    }

    this.createUniqueObjectString = function (object, base) {
        base = base ? base : "";
        for (let key in object) {
            const value = object[key];
            if (value) {
                base += "&" + key + "=" + value;
            }
        }
        return base;
    }

    this.isNumber = function (value) {
        return value === "0" || value === 0 || (!!value && !!parseFloat(value));
    }
    this.isString = function (value, preventNumeric) {
        return typeof value === 'string' || value instanceof String && (!preventNumeric || value.match(/^[0-9]+$/) !== null);
    }

    this.uppercaseFirst = function (string) {
        return string ? string[0].toUpperCase() + string.slice(1).toLowerCase() : "";
    }

    this.uppercaseFirstWords = function (string) {
        const words = string ? string.toString().split(" ") : "";
        let ret = "";
        for (let i = 0; i < words.length; i++) {
            let word = words[i];
            if (!word) {
                continue;
            }
            word = helper.uppercaseFirst(word);
            ret += word + " ";
        }
        return ret.trim()
    }

    this.formatPhoneNumber = function (phoneNumber, countryCode) {
        if (!phoneNumber) {
            return ""
        }

        countryCode = countryCode ? countryCode : '0044';
        const countryCodeLength = countryCode.length;
        phoneNumber.replace(/ /g, ""); // remove spaces
        phoneNumber.replace('+', '00'); // exchange + for 0
        phoneNumber.replace('(0)', ''); // remove optional (0)

        for (let i = 0; i < phoneNumber.length; i++) {
            phoneNumber = phoneNumber.split(' ').join('');
        }

        const subst = phoneNumber.substring(0, countryCodeLength);
        const char1 = phoneNumber.substring(0, 1);
        const without0 = phoneNumber.substring(1);

        if (subst !== countryCode && char1 === "0") {
            phoneNumber = countryCode + without0;
        }

        return phoneNumber;
    }

    this.isDateExpired = function (date) {
        if (helper.isString(date, true)) {
            date = Date.parse(date);
        }
        return date <= new Date().getTime();
    }

    this.nl2br = function (string) {
        return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    this.splitTitleTxt = function (text) {
        const all = text ? text.split(" ") : null;
        if (all && all.length > 0) {
            const thirdOfWay = all.length / 3;
            const twoThirdsOfWay = thirdOfWay * 2;

            text = "";
            let middleStarted = false;
            let middleEnded = false;
            for (let i = 0; i < all.length; i++) {
                if (!middleStarted) {
                    if ((i + 1) >= thirdOfWay) {
                        middleStarted = true;
                        text += '<span>';
                    }
                } else if (!middleEnded) {
                    if ((i + 1) >= twoThirdsOfWay) {
                        middleEnded = true;
                        text += '</span>';
                    }
                }
                text += " " + all[i];
            }

            if (middleStarted && !middleEnded) {
                text += '</span>';
            }

        }
        return text;
    }

    this.rtrim = function(str, ch)
    {
        let i = str.length - 1;

        while (ch === str.charAt(i) && i >= 0) i--

        return str.substring(0, i + 1);
    }

    this.anyDescription = function (item) {
        let description = item._description ? item._description : item.description;
        description = description ? description : "";

        const checkDescription = description.split("_").join(" ");
        let range, colour, style
        const rangeName = item.range_name;
        const colourName = item.colour_name;
        const styleName = item.style_name;

        if (rangeName && helper.isString(rangeName)) {
            range = rangeName.toLowerCase();
        } else {
            range = item.range && helper.isString(item.range) && item.range !== "_default" ? item.range : "";
            range = range.split("_").join(" ");
        }

        if (colourName && helper.isString(colourName)) {
            colour = colourName.toLowerCase();
        } else {
            colour = item.colour && helper.isString(item.colour) && item.colour !== "_default" ? item.colour : "";
            colour = colour.split("_").join(" ");
        }

        if (styleName && helper.isString(styleName)) {
            style = styleName.toLowerCase();
        } else {
            style = item.style && helper.isString(item.style) && item.style !== "_default" && item.style !== item.range ? item.style : "";
            style = style.split("_").join(" ");
        }


        let prefix = "";
        let suffix = "";
        if (colour || style) {
            if ((!colour || !checkDescription.toLowerCase().includes(colour)) && (!style || !checkDescription.toLowerCase().includes(style))) {
                if (range && !checkDescription.toLowerCase().includes(range) && !colour.toLowerCase().includes(range)) {
                    prefix += helper.uppercaseFirstWords(range) + " ";
                }
                if (colour) {
                    prefix += helper.uppercaseFirstWords(colour) + " ";
                }
                if (style) {
                    prefix += helper.uppercaseFirstWords(style) + " ";
                }
            }
        }
        let width = item.width;
        let height = item.height;
        let hadWidth = false;
        let hadHeight = false;
        if(width && checkDescription.toLowerCase().includes(width)){
            hadWidth = true;
            width = 0;
        }
        if(height && checkDescription.toLowerCase().includes(height)){
            hadHeight = true;
            height = 0;
        }

        if (width && height) {
            prefix += height + "x" + width + " ";
        } else if (width) {
            if(!hadHeight){
                prefix += width + " ";
            } else {
                suffix += width + "w ";
            }
        } else if (height) {
            if(!hadWidth){
                prefix += height + " ";
            } else {
                suffix += height + "h ";
            }
        }

        suffix = suffix ? (" " + suffix) : "";

        return (prefix + description + suffix).trim()
    }

    function findMultipleMessages(message) {
        const toAddMessages = [];
        if (helper.isObject(message)) {
            for (let key in message) {
                if (message[key]) {
                    toAddMessages.push(helper.requireString(message[key]));
                }
            }
        } else if (helper.isArray(message)) {
            for (let i = 0; i < message.length; i++) {
                if (message[i]) {
                    toAddMessages.push(helper.requireString(message[i]));
                }
            }
        } else {
            if (message) {
                toAddMessages.push(helper.requireString(message));
            }
        }
        if (toAddMessages.length === 0) {
            toAddMessages.push("");
        }
        return toAddMessages;
    }

    this.addErrorMessage = function (message, messages, messageID, appPrefix) {
        messages = messages ? messages : [];
        const toAddMessages = findMultipleMessages(message);
        for (let i = 0; i < toAddMessages.length; i++) {
            const toAddMessage = toAddMessages[i];
            messages.push({
                type: 'danger',
                msg: !appPrefix && toAddMessage ? toAddMessage : 'An error has occurred!' + (toAddMessage ? ' ERROR - ' + toAddMessage : ''),
                message_id: messageID
            });
        }
        return messages;
    }

    this.addSuccessMessage = function (message, messages, messageID) {
        messages = messages ? messages : [];
        const toAddMessages = findMultipleMessages(message);
        for (let i = 0; i < toAddMessages.length; i++) {
            const toAddMessage = toAddMessages[i];
            messages.push({
                type: 'success',
                msg: toAddMessage ? toAddMessage : 'Success',
                message_id: messageID
            });
        }
        return messages;
    }

    this.getLetteredNumbers = function (amtNumbers) {
        const baseChar = ("A").charCodeAt(0);

        const letteredNumbers = [];
        for (let nextNumber = 1; nextNumber <= amtNumbers; nextNumber++) {

            let letteredNumber = "";
            let number = nextNumber;
            while (number > 0) {
                number -= 1;
                letteredNumber = String.fromCharCode(baseChar + (number % 26)) + letteredNumber;
                number = (number / 26) >> 0; // quick `floor`
            }
            letteredNumbers.push(letteredNumber)
        }
        return letteredNumbers;
    }

    this.collectExcelFromTable = function (table) {

        function getColumns(rowContainer) {
            if (rowContainer && rowContainer.length > 0) {
                const tr = rowContainer[0].getElementsByTagName("tr");
                if (tr && tr.length > 0) {
                    let th = tr[0].getElementsByTagName("th");
                    if (!th || th.length === 0) {
                        th = tr[0].getElementsByTagName("td");
                    }
                    if (th && th.length > 0) {
                        const columns = [];
                        for (let i = 0; i < th.length; i++) {
                            const thElement = th[i];
                            const header = thElement.dataset.header ? thElement.dataset.header : thElement.innerText;
                            const key = thElement.dataset.key ? thElement.dataset.key : "col_" + i;
                            const width = thElement.dataset.width ? thElement.dataset.width : null;
                            const clientWidth = !width ? thElement.clientWidth : null;
                            const fontName = thElement.dataset.fontName ? thElement.dataset.fontName : null;
                            const fontSize = thElement.dataset.fontSize ? thElement.dataset.fontSize : null;
                            let style = null;
                            if (fontName || fontSize) {
                                style = {
                                    font: {
                                        name: fontName,
                                        size: fontSize
                                    }
                                }
                            }
                            columns.push({
                                header: header,
                                key: key,
                                width: width,
                                client_width: clientWidth,
                                style: style
                            })
                        }

                        return columns;
                    }
                }
            }
            return null;
        }

        let i, tr, j, td, row, k, column;
        let columns = null;
        let rows = null;
        if (table) {
            const thead = table.getElementsByTagName("thead");
            columns = getColumns(thead);
            let tbody = table.getElementsByTagName("tbody");
            if (!tbody || tbody.length === 0) {
                if (!columns) {
                    tbody = [table];
                }
            }
            if (tbody && tbody.length > 0) {
                let ignoreFirst = false;
                if (!columns) {
                    columns = getColumns(tbody);
                    ignoreFirst = true;
                }
                if (columns) {
                    rows = [];
                    for (i = 0; i < tbody.length; i++) {
                        tr = tbody[i].getElementsByTagName("tr");
                        if (tr && tr.length > 0) {
                            for (j = 0; j < tr.length; j++) {
                                if (ignoreFirst && i === 0 && j === 0) {
                                    continue;
                                }
                                td = tr[j].querySelectorAll('td,th');

                                if (td && td.length > 0) {
                                    row = {}
                                    for (k = 0; k < columns.length; k++) {
                                        column = columns[k];
                                        row[column.key] = {value: k < td.length ? td[k].innerText : ""}
                                    }
                                    rows.push(row)
                                }
                            }
                        }
                    }
                    const tfoot = table.getElementsByTagName("tfoot");
                    if (tbody) {
                        for (i = 0; i < tfoot.length; i++) {
                            tr = tfoot[i].getElementsByTagName("tr");
                            if (tr && tr.length > 0) {
                                for (j = 0; j < tr.length; j++) {
                                    td = tr[j].querySelectorAll('td,th');
                                    if (td && td.length > 0) {
                                        row = {}
                                        for (k = 0; k < columns.length; k++) {
                                            column = columns[k];
                                            row[column.key] = {
                                                value: k < td.length ? td[k].innerText : "",
                                                is_footer: true
                                            }
                                        }
                                        rows.push(row)
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }
        return row ? {columns: columns, rows: rows} : null;
    }

    this.exportExcelTable = function (table, fileName, params) {
        const $table = $(table);
        $table.addClass("preparing-excel");

        const columnsAndRows = helper.collectExcelFromTable(table);
        if (!columnsAndRows) {
            return;
        }
        const columns = columnsAndRows.columns;
        const rows = columnsAndRows.rows;
        params = params ? params : {};

        params.max_width = params.hasOwnProperty("max_width") ? parseInt(params.max_width) : 200;
        params.min_col_width = params.min_col_width ? parseInt(params.min_col_width) : 10;
        params.header = params.hasOwnProperty("header") ? params.header : {
            border: {
                top: {style: 'none'},
                left: {style: 'none'},
                bottom: {style: 'medium', color: {argb: '00000000'}},
                right: {style: 'none'}
            }
        }
        params.footer = params.hasOwnProperty("header") ? params.header : {
            border: {
                top: {style: 'medium', color: {argb: '00000000'}},
                left: {style: 'none'},
                bottom: {style: 'none'},
                right: {style: 'none'}
            }
        }
        helper.exportExcel(columns, rows, fileName, params, function () {
            $table.removeClass("preparing-excel");
        });
    }

    this.exportExcel = function (columns, rows, fileName, params, preWriteCallback) {
        let i, key, column;

        params = params ? params : {};


        const maxWidth = params.max_width && parseInt(params.max_width) > 0 ? parseInt(params.max_width) : 0;
        const minColWidth = params.min_col_width && parseInt(params.min_col_width) > 0 ? parseInt(params.min_col_width) : 0;
        let remainingWidth = maxWidth;
        let totalClientWidth = 0;
        for (i = 0; i < columns.length; i++) {
            column = columns[i];
            if (column.width) {
                remainingWidth -= column.width;
            } else if (column.client_width) {
                totalClientWidth += column.client_width;
            }
        }
        for (i = 0; i < columns.length; i++) {
            column = columns[i];
            if (!column.width) {
                if (column.client_width) {
                    if (maxWidth) {
                        if (params.break_size) {
                            column.width = Math.min(column.client_width, maxWidth);
                        } else {
                            column.width = Math.max(column.client_width ? Math.round((column.client_width / totalClientWidth) * remainingWidth) : 0, minColWidth);
                        }
                    } else {
                        column.width = column.client_width;
                    }
                } else if (minColWidth) {
                    column.width = minColWidth;
                } else {
                    column.width = 10;
                }
            }

            if (params.header) {
                if (params.header.border) {
                    //column.border = params.header.border;
                }
            }
            delete column.client_width;
        }

        const columnLetters = helper.getLetteredNumbers(columns.length)

        const excelJS = window.ExcelJS;
        const workbook = new excelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileName);

        worksheet.columns = columns;

        for (i = 0; i < rows.length; i++) {
            const rowValues = {};
            for (key in rows[i]) {
                rowValues[key] = rows[i][key].value
            }
            worksheet.addRow(rowValues, "n");
        }

        if (params.header) {
            if (params.header.border) {
                for (i = 0; i < columnLetters.length; i++) {
                    worksheet.getCell(columnLetters[i] + "1").border = params.header.border;
                }
            }
        }

        if (params.footer) {
            if (params.footer.border) {
                let footerIndex = -1;
                for (i = 0; i < rows.length; i++) {
                    for (key in rows[i]) {
                        if (rows[i][key].is_footer) {
                            footerIndex = i;
                        }
                        break;
                    }
                    if (footerIndex >= 0) {
                        break;
                    }
                }
                if (footerIndex >= 0) {
                    for (i = 0; i < columnLetters.length; i++) {
                        worksheet.getCell(columnLetters[i] + (footerIndex + 1)).border = params.footer.border;
                    }
                }
            }
        }

        if (preWriteCallback) {
            preWriteCallback();
        }
        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            window.saveAs(blob, (fileName ? fileName : 'excel_doc') + '.xlsx');

        })
    }
    this.doesMatchPath = function (path, compareAgainst) {
        path = path ? path : "";
        compareAgainst = compareAgainst ? compareAgainst : "";

        if (path.substr(path.length - 1) === "/") {
            path = path.slice(0, -1)
        }
        if (compareAgainst.substr(compareAgainst.length - 1) === "/") {
            compareAgainst = compareAgainst.slice(0, -1)
        }
        if (path.substring(0, 1) !== "/") {
            path = "/" + path;
        }
        if (compareAgainst.substring(0, 1) !== "/") {
            compareAgainst = "/" + compareAgainst;
        }
        if (compareAgainst === path) {
            return true;
        }
        if (compareAgainst === "/") {
            return false;
        }
        return compareAgainst.substring(0, path.length) === path && compareAgainst.substring(0, path.length + 1) === path + "/";
    }

    this.printWindow = function () {
        window.print();
    };

    this.numberWithCommas = function (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

}]);